import environmentVariables from './utils/get-environment-variables';

const apiContextPath = environmentVariables.REACT_APP_RUNTIME_API_URL;

export default {
    development: {
        apiContextPath,
    },
    production: {
        apiContextPath,
    },
    apiUrl: process.env.REACT_APP_API_URL,
    rollbarToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
    appEnv: process.env.REACT_APP_BUILDTIME_APP_ENV,
    hostName: process.env.REACT_APP_HOST_NAME,
    runtimeApiUrl: process.env.REACT_APP_RUNTIME_API_URL,
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    herokuSlugCommit: process.env.REACT_APP_HEROKU_SLUG_COMMIT,
    herokuPiplineEnv: process.env.REACT_APP_HEROKU_PIPELINE_ENV,
    applicationEnv: process.env.REACT_APP_ENV
}
// [process.env.NODE_ENV || 'development'];
